export default {
  "content": "<path d=\"M12.207 14.207L6.414 20H10.5v2H4a1 1 0 01-1-1v-6.5h2v4.086l5.793-5.793 1.414 1.414zM21 3a1 1 0 011 1v6.5h-2V6.414l-5.793 5.793-1.414-1.414L18.586 5H14.5V3H21z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};